import React from 'react';
import { useLanguageStore } from '../stores/useLanguageStore';
import { Globe } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LanguageOption {
  code: string;
  name: string;
  flag: string;
}

const languages: LanguageOption[] = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
];

export const LanguageSwitcher: React.FC = () => {
  const { locale, setLocale } = useLanguageStore();

  return (
    <div className="flex items-center gap-2">
      <Globe className="w-4 h-4 text-muted-foreground" />
      <div className="flex gap-1">
        {languages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => setLocale(lang.code)}
            className={cn(
              'px-3 py-1 rounded-md text-sm font-medium transition-colors',
              locale === lang.code
                ? 'bg-primary text-primary-foreground'
                : 'bg-background text-foreground border border-border hover:bg-accent'
            )}
            title={lang.name}
          >
            {lang.flag}
          </button>
        ))}
      </div>
    </div>
  );
};

